import mori from 'mori';
import {
  processCellCallback,
  downloader,
  cleanCSV,
}
  from '../../../datacenter/app/js/services/processTableDataForDownload';
import { renderNotes }
  from '../../../datacenter/app/js/services/renderData';

export default function downloadCSV(
  api,
  table,
  timeframes,
  config,
  immutableHeaders,
  immutableDataviews
) {
  const notes = mori.intoArray(renderNotes(config, timeframes, {})).reduce(
      (prev, curr) =>
         `${prev}"${curr.name}"\n${curr.val.reduce(
          (prev1, curr1) => `${prev1}"${curr1.Note
            .replace(/["\u201C\u201D]/g, '""')
            .split('\n').join('"\n"')}"\n`,
          ''
        )}\n`,
      '\n'
    );

  const headers = mori.filter(
    (item) => 'Location' === mori.get(item, 'type') ||
      mori.get(item, 'type') === mori.get(
        immutableDataviews,
        /* this.router.currentParams.dataView || */ 0
      ).type
    , immutableHeaders
  );

  const customHeader = [
    `"Title: ${document.title}"`,
    `"Timeframe: ${timeframes[0]}"`,
    '', // Empty string so we can get a newline at EOL
  ].join('\n');

  const customFooter = [
    notes,
  ].join('\n');

  const dataAsCsv = api.getDataAsCsv({
    customFooter,
    customHeader,
    processCellCallback: processCellCallback(headers),
  });

  downloader('raw_data.csv', cleanCSV(dataAsCsv));
}



// WEBPACK FOOTER //
// ./app/services/downloadCSV.js